import React from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';

// Constants
import { EMPTY_ARRAY, EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import Button from '../../atoms/Button';
import ToolTip from '../../atoms/tooltip';
import ButtonWithMenu from '../buttonWithMenu';
import './_saveComponent.scss';
var SaveSetting = function SaveSetting(props) {
  var onPrimaryAction = props.onPrimaryAction,
    onSecondaryAction = props.onSecondaryAction,
    primaryButtonType = props.primaryButtonType,
    secondaryButtonType = props.secondaryButtonType,
    primaryButtonLabel = props.primaryButtonLabel,
    secondaryButtonLabel = props.secondaryButtonLabel,
    isPrimaryDisabled = props.isPrimaryDisabled,
    isSecondaryDisabled = props.isSecondaryDisabled,
    primaryActionView = props.primaryActionView,
    secondaryActionView = props.secondaryActionView,
    primaryActionLoading = props.primaryActionLoading,
    secondaryActionLoading = props.secondaryActionLoading,
    showTertiaryButton = props.showTertiaryButton,
    tertiaryActionView = props.tertiaryActionView,
    isTertiaryDisabled = props.isTertiaryDisabled,
    onTertiaryAction = props.onTertiaryAction,
    tertiaryButtonType = props.tertiaryButtonType,
    tertiaryButtonLabel = props.tertiaryButtonLabel,
    tertiaryActionLoading = props.tertiaryActionLoading,
    showSecondaryButton = props.showSecondaryButton,
    id = props.id,
    onAdditionalAction = props.onAdditionalAction,
    additionalButtonType = props.additionalButtonType,
    additionalButtonLabel = props.additionalButtonLabel,
    additionalActionLoading = props.additionalActionLoading,
    showAdditionalButton = props.showAdditionalButton,
    additionalActionView = props.additionalActionView,
    isAdditionalDisabled = props.isAdditionalDisabled,
    containerClassName = props.containerClassName,
    showPrimaryButton = props.showPrimaryButton,
    primaryClassName = props.primaryClassName,
    secondaryClassName = props.secondaryClassName,
    tertiaryClassName = props.tertiaryClassName,
    renderAdditionalFooterDetail = props.renderAdditionalFooterDetail,
    className = props.className,
    tertiaryButtonToolTipTitle = props.tertiaryButtonToolTipTitle,
    secondaryButtonToolTipTitle = props.secondaryButtonToolTipTitle,
    primaryButtonToolTipTitle = props.primaryButtonToolTipTitle,
    additionalButtonToolTipTitle = props.additionalButtonToolTipTitle,
    toolTipTriggerEvent = props.toolTipTriggerEvent,
    actionContainerClassName = props.actionContainerClassName,
    showPrimaryButtonWithMenu = props.showPrimaryButtonWithMenu,
    primaryActionViewWithMenu = props.primaryActionViewWithMenu,
    onPrimaryActionWithMenu = props.onPrimaryActionWithMenu,
    buttonWithMenuButtonProps = props.buttonWithMenuButtonProps,
    primaryButtonMenuOptions = props.primaryButtonMenuOptions,
    primaryActionLoadingWithMenu = props.primaryActionLoadingWithMenu;
  return /*#__PURE__*/React.createElement("div", {
    className: "save-container ".concat(containerClassName, " automation_selector_save_container"),
    id: id
  }, /*#__PURE__*/React.createElement("div", {
    className: "button-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tertiary-component"
  }, showTertiaryButton && /*#__PURE__*/React.createElement(ToolTip, {
    placement: "top",
    trigger: toolTipTriggerEvent,
    title: tertiaryButtonToolTipTitle
  }, /*#__PURE__*/React.createElement(Button, {
    view: tertiaryActionView,
    disabled: isTertiaryDisabled,
    onClick: onTertiaryAction,
    type: tertiaryButtonType,
    loading: tertiaryActionLoading,
    className: tertiaryClassName
  }, tertiaryButtonLabel))), /*#__PURE__*/React.createElement("div", {
    className: "save-component ".concat(className)
  }, renderAdditionalFooterDetail(), /*#__PURE__*/React.createElement("div", {
    className: "action-container ".concat(actionContainerClassName)
  }, showSecondaryButton && /*#__PURE__*/React.createElement(ToolTip, {
    placement: "top",
    trigger: toolTipTriggerEvent,
    title: secondaryButtonToolTipTitle
  }, /*#__PURE__*/React.createElement(Button, {
    view: secondaryActionView,
    disabled: isSecondaryDisabled,
    onClick: onSecondaryAction,
    type: secondaryButtonType,
    className: secondaryClassName,
    loading: secondaryActionLoading
  }, secondaryButtonLabel)), showPrimaryButton && /*#__PURE__*/React.createElement(ToolTip, {
    placement: "top",
    trigger: toolTipTriggerEvent,
    title: primaryButtonToolTipTitle
  }, /*#__PURE__*/React.createElement(Button, {
    className: "primary-action ".concat(primaryClassName),
    view: primaryActionView,
    type: primaryButtonType,
    disabled: isPrimaryDisabled,
    onClick: onPrimaryAction,
    loading: primaryActionLoading
  }, primaryButtonLabel)), showPrimaryButtonWithMenu && /*#__PURE__*/React.createElement(ButtonWithMenu, {
    className: "primary-menu-action",
    view: primaryActionViewWithMenu,
    onClick: onPrimaryActionWithMenu,
    loading: primaryActionLoadingWithMenu,
    options: primaryButtonMenuOptions,
    buttonProps: buttonWithMenuButtonProps
  }), showAdditionalButton && /*#__PURE__*/React.createElement(ToolTip, {
    placement: "top",
    trigger: toolTipTriggerEvent,
    title: additionalButtonToolTipTitle
  }, /*#__PURE__*/React.createElement(Button, {
    className: "additional-action",
    view: additionalActionView,
    disabled: isAdditionalDisabled,
    onClick: onAdditionalAction,
    type: additionalButtonType,
    loading: additionalActionLoading
  }, additionalButtonLabel))))));
};
SaveSetting.propTypes = {
  primaryButtonLabel: PropTypes.string,
  secondaryButtonLabel: PropTypes.string,
  onPrimaryAction: PropTypes.func.isRequired,
  onSecondaryAction: PropTypes.func.isRequired,
  isPrimaryDisabled: PropTypes.bool,
  isSecondaryDisabled: PropTypes.bool,
  primaryButtonType: PropTypes.string,
  secondaryButtonType: PropTypes.string,
  primaryActionView: PropTypes.string,
  secondaryActionView: PropTypes.string,
  primaryActionLoading: PropTypes.bool,
  secondaryActionLoading: PropTypes.bool,
  tertiaryActionView: PropTypes.string,
  containerClassName: PropTypes.string,
  showTertiaryButton: PropTypes.bool,
  isTertiaryDisabled: PropTypes.bool,
  showSecondaryButton: PropTypes.bool,
  onTertiaryAction: PropTypes.func,
  tertiaryButtonType: PropTypes.string,
  tertiaryButtonLabel: PropTypes.string,
  tertiaryActionLoading: PropTypes.bool,
  onAdditionalAction: PropTypes.func,
  additionalButtonType: PropTypes.string,
  additionalButtonLabel: PropTypes.string,
  additionalActionLoading: PropTypes.bool,
  additionalActionView: PropTypes.string,
  showAdditionalButton: PropTypes.bool,
  isAdditionalDisabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  showPrimaryButton: PropTypes.bool,
  primaryClassName: PropTypes.string,
  secondaryClassName: PropTypes.string,
  tertiaryClassName: PropTypes.string,
  className: PropTypes.string,
  renderAdditionalFooterDetail: PropTypes.func,
  tertiaryButtonToolTipTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  secondaryButtonToolTipTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  primaryButtonToolTipTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  additionalButtonToolTipTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  toolTipTriggerEvent: PropTypes.string,
  actionContainerClassName: PropTypes.string,
  showPrimaryButtonWithMenu: PropTypes.bool,
  primaryActionViewWithMenu: PropTypes.string,
  onPrimaryActionWithMenu: PropTypes.func,
  buttonWithMenuButtonProps: PropTypes.object,
  primaryButtonMenuOptions: PropTypes.array,
  primaryActionLoadingWithMenu: PropTypes.bool
};
SaveSetting.defaultProps = {
  primaryButtonLabel: __('Save'),
  secondaryButtonLabel: __('Cancel'),
  isPrimaryDisabled: false,
  isSecondaryDisabled: false,
  primaryButtonType: 'button',
  className: '',
  secondaryButtonType: 'button',
  primaryActionView: 'primary',
  secondaryActionView: 'secondary',
  primaryActionLoading: false,
  secondaryActionLoading: false,
  tertiaryActionView: 'secondary',
  showTertiaryButton: false,
  isTertiaryDisabled: false,
  onTertiaryAction: _noop,
  tertiaryButtonType: 'button',
  tertiaryButtonLabel: __('Delete'),
  showSecondaryButton: true,
  tertiaryActionLoading: false,
  onAdditionalAction: _noop,
  additionalButtonType: 'button',
  additionalButtonLabel: __('Untitled'),
  additionalActionLoading: false,
  showAdditionalButton: false,
  isAdditionalDisabled: false,
  additionalActionView: 'secondary',
  containerClassName: '',
  showPrimaryButton: true,
  primaryClassName: '',
  secondaryClassName: '',
  tertiaryClassName: '',
  renderAdditionalFooterDetail: _noop,
  tertiaryButtonToolTipTitle: null,
  secondaryButtonToolTipTitle: null,
  primaryButtonToolTipTitle: null,
  additionalButtonToolTipTitle: null,
  toolTipTriggerEvent: 'hover',
  actionContainerClassName: undefined,
  showPrimaryButtonWithMenu: false,
  primaryActionViewWithMenu: ButtonWithMenu.VIEW.PRIMARY,
  onPrimaryActionWithMenu: _noop,
  buttonWithMenuButtonProps: EMPTY_OBJECT,
  primaryButtonMenuOptions: EMPTY_ARRAY,
  primaryActionLoadingWithMenu: false
};
export default SaveSetting;